import React from 'react';
import styled from 'styled-components';
import { isValidInteger } from '../utils/validator';

interface Props {
	value: number|undefined
	minValue: number
	maxValue: number
	onChange: (value: number|undefined) => void
	createValidationError: (value: number) => string
}

const Container = styled.div`
	margin: auto;
	max-width: 8rem;
`;

const NumberArea = styled.div`
	font-size: 3rem;
	width: 6rem;
	display: inline-block;
	float: left;
	*:focus {
		outline: none;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
	}`;

const Buttons = styled.div`
	font-size: 2.5rem;
	float: right;
	margin-top: -20px;
	width: 0.4em;
`;

const Plus = styled.div`
	background: red;
	border-radius: 0.8em;
	color: #ffffff;
	display: inline-block;
	line-height: 1.2em;
	text-align: center;
	width: 1.2em;
	position: relative;
	font-size: 0.6em;
	margin: 1px;
`;

const Minus = styled.div`
	font-size: 0.6em;
	background: red;
	-moz-border-radius: 0.8em;
	-webkit-border-radius: 0.8em;
	color: #ffffff;
	display: block;
	line-height: 1.2em;
	text-align: center;
	width: 1.2em;
	position: relative;
`;

const NumberInput = styled.input`
	text-align: center;
	font-size: 1.3em;
	line-height: 4rem;
	width: 6.5rem;
	border: 0px;
	border-bottom: dashed 1px  #969696;
`;

export const Counter: React.FC<Props> = (props: Props) => {

	const setValue = (value: number) => {
		if ((value >= props.minValue) && (value <= props.maxValue)) {
			props.onChange(value);
		} else {
			setTimeout(() => alert(props.createValidationError(value)), 100);  // Some delay so that the component can render the modified value (if onChange listener in the parent component causes that)
			props.onChange(Math.min(Math.max(value, props.minValue), props.maxValue));
		}
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;
		if (isValidInteger(inputValue)) {
			setValue(parseInt(inputValue));
		} else {
			props.onChange(undefined);
		}
	};

	const changeValue = (increment: number) => {
		if (props.value !== undefined) {
			setValue(props.value + increment);
		} else {
			setValue(props.minValue);	// Some default value (min value is good for plus click and quite sensible for minus click)
		}
	};

	return (
		<Container>
			<NumberArea>
				<NumberInput value={(props.value !== undefined) ? props.value : ''} onChange={handleInputChange}/>
			</NumberArea>
			<Buttons>
				<Plus onClick={() => changeValue(1)}>+</Plus> <br />
				<Minus onClick={() => changeValue(-1)}>-</Minus>
			</Buttons>
		</Container>
	);
};
